export const DEFAULT_ES_TARGET_YEAR = 2022;
export const DEFAULT_ES_TARGET_NAME = `es${DEFAULT_ES_TARGET_YEAR.toString()}`;
